import React from 'react';

const NextStop: React.FC = () => {
  return <div className="card"><h1>Neste Stopp</h1><p>TODO: Show next location with map</p></div>;
};

export default NextStop;
